import { Fragment, useEffect } from "react";

import Slider from "react-slick";

import TestimonialsSec from "../components/home/testimonialsSec/TestimonialsSec";
import TopPropertiesSec from "../components/home/topPropertiesSec/TopPropertiesSec";
import WhyChoose from "../components/home/whychoosesec/WhyChoose";

import CartBackImg from "../assets/images/cart-back.png";
import Property1Img from "../assets/images/property1.png";
import Property2Img from "../assets/images/property2.png";
import Property3Img from "../assets/images/property3.png";
import { useStaticPageContent } from "../hooks/useStaticPageContent";
import { staticContentDefaults } from "../data/staticContentDefaults";
import { getStaticContentImage } from "../utils/staticContentImages";
import CmsRichText from "../components/common/CmsRichText";

const defaultCarouselImages = [Property1Img, Property2Img, Property3Img];

const AboutUs = () => {
  const pageContent = useStaticPageContent("about-us");
  const banner =
    pageContent?.banner || staticContentDefaults["about-us"].banner;
  const aboutContent =
    pageContent?.aboutContent ||
    staticContentDefaults["about-us"].aboutContent;
  const carouselSlides = pageContent?.carouselSlides?.length
    ? pageContent.carouselSlides
    : staticContentDefaults["about-us"].carouselSlides;

  const settings = {
    dots: true, // Enable indicators
    slidesToShow: 1,
    infinite: true,
    speed: 500,
    autoplaySpeed: 2000,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1023, // Small screens
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 991, // Small screens
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 767, // Small screens
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 499, // Small screens
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
  }, []);
  return (
    <Fragment>
      <div className="banner-section cart-banner contact">
        <img src={getStaticContentImage(banner.image, CartBackImg)} alt="..." />
        <h1>
          <CmsRichText as="span" value={banner.title} />
        </h1>
      </div>

      <div className="aboutus">
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-7 col-md-7">
              <div className="about-content-sec">
                <h2>
                  <CmsRichText as="span" value={aboutContent.heading} />
                </h2>
                <CmsRichText as="div" className="cms-rich-text-block" value={aboutContent.bodyHtml} />
              </div>
            </div>
            <div className="col-12 col-lg-5 col-md-5">
              <Slider {...settings}>
                {carouselSlides.map((slide, index) => (
                  <div className="property-sec" key={`${slide.badge}-${index}`}>
                    <div className="property-inner">
                      <span className="type-pro">
                        <CmsRichText as="span" value={slide.badge} />
                      </span>
                      <img
                        src={getStaticContentImage(
                          slide.image,
                          defaultCarouselImages[index]
                        )}
                      />
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
      <WhyChoose />
      <div className="top-property-sec">
        <TopPropertiesSec />
      </div>
      <div className="about-inner">
  
      </div>
    </Fragment>
  );
};

export default AboutUs;
